import React, { createContext, useEffect, useMemo, useState } from "react";

export const CartContext = createContext();

const readStorage = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => readStorage("cartItems", []));
  const [wishlist, setWishlist] = useState(() => readStorage("wishlist", []));

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);
  useEffect(() => localStorage.setItem("wishlist", JSON.stringify(wishlist)), [wishlist]);

  const addToCart = (productId, quantity = 1, size = "One size", color = "Natural") => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find(
        (item) =>
          item.id === productId && item.size === size && item.color === color
      );

      if (existingItem) {
        return prevItems.map((item) =>
          item.id === productId && item.size === size && item.color === color
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prevItems, { id: productId, size, color, quantity }];
    });
  };

  const removeFromCart = (productId, size, color) => {
    setCartItems((prevItems) =>
      prevItems.filter(
        (item) =>
          !(item.id === productId && item.size === size && item.color === color)
      )
    );
  };

  const updateQuantity = (productId, size, color, quantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId && item.size === size && item.color === color
          ? { ...item, quantity: Math.max(1, quantity) }
          : item
      )
    );
  };

  const toggleWishlist = (productId) =>
    setWishlist((items) =>
      items.includes(productId) ? items.filter((id) => id !== productId) : [...items, productId]
    );

  const value = useMemo(
    () => ({
      cartItems,
      wishlist,
      addToCart,
      removeFromCart,
      clearCart: () => setCartItems([]),
      updateQuantity,
      toggleWishlist,
    }),
    [cartItems, wishlist]
  );

  return (
    <CartContext.Provider value={value}>{children}</CartContext.Provider>
  );
};
